
import Vue from "vue";
import {
  emailRule,
  minLengthRule,
  phoneRule,
  requiredRule,
} from "@/services/helpers/validation-rules";
import { mask } from "vue-the-mask";
/**/
import LangSwitcher from "@/components/settings/LangSwitcher.vue";
import PhonePicker from "@/components/form-components/PhonePicker.vue";
import { timeToStart, timeToEnd } from "@/config/registrationWindow";
/**/
export default Vue.extend({
  name: "RegisterClient",

  /**/
  components: { LangSwitcher, PhonePicker },
  /**/

  directives: {
    mask,
  },

  data: () => ({
    model: {} as any,
    errorMessages: {},
    showPassword: {
      current: false as boolean,
      repeat: false as boolean,
    } as { [value: string]: boolean },
    errors: {},
    loading: false,
    usmfLogo: require("@/assets/images/usmf-logo.png"),
    currentDate: new Date(),
    timeToStart,
    timeToEnd,
  }),

  computed: {
    rules() {
      return {
        emailRule: emailRule.bind(this),
        requiredRule: requiredRule.bind(this),
        minLengthRule: minLengthRule.bind(this),
        phoneRule: phoneRule.bind(this),
        identityPassword: (v: string): string | boolean =>
          v === this.model.password || "Parolele nu coincid",
      };
    },
    blocked() {
      return (
        this.currentDate < new Date(this.timeToStart) ||
        this.currentDate > new Date(this.timeToEnd)
      );
    },
  },

  methods: {
    toggleShowPassword(type: string) {
      this.showPassword[type] = !this.showPassword[type];
    },
    async submit() {
      if ((this.$refs.form as Vue).validate()) {
        try {
          await this.$API.auth().registerClient(this.model);

          await this.$router.push(`/auth/email-sent/${this.model.email}`);
        } catch (e) {
          if (e.hasOwnProperty("errors")) {
            this.errorMessages = e.errors;
            setTimeout(() => {
              this.errorMessages = {};
            }, 3000);
          }
          await this.$store.dispatch("alert/showError", e.message);
        }
      }
    },
  },
});
